<template>
  <div>
    举报前台_举报注册
    <!-- <div class="login">
      <div class="password_login">密码登陆</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item prop="username">
          <el-input v-model="ruleForm.username" placeholder="请输入用户名/邮箱"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="ruleForm.password" placeholder="请输入用户密码"></el-input>
        </el-form-item>
        <el-form-item class="yzm_btn">
          <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
        <div>
          <div class="forgetPassword" @click="forgetPassword">忘记密码</div>
          <div class="registered">
            <span class="no_account">没有账号</span>
            <span class="now_registered" @click="nowRegistered">立即注册</span>
          </div>
        </div>
      </el-form>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Registration",
  data() {
    return {
      ruleForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名/邮箱", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
        
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    forgetPassword() {
    
    },
    nowRegistered() {
      
    }
  }
};
</script>

<style scoped>
.login {
  width: 300px;
  padding: 30px 20px;
  background: #fff;
  position: absolute;
  right: 130px;
  top: 45%;
  box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 0.1);
  transform: translateY(-50%);
}
.password_login {
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
}
.login >>> .el-input input {
  padding: 0;
  text-indent: 2px;
  display: inline-block;
  border-radius: 0;
  width: 100%;
  height: 35px;
  /* margin: 16px 0 0; */
  outline: none;
  border: 0;
  border-bottom: 1px solid #cccc;
}
.login >>> .el-form-item__content {
  margin-left: 0 !important;
  margin-bottom: 15px;
}
.forgetPassword,
.registered {
  margin: 5px 0 8px;
  cursor: pointer;
  display: inline-block;
  color: #3a5af9;
  font-size: 14px;
}

.registered {
  float: right;
}

.no_account {
  cursor: default;
  color: #ccc;
}

.yzm_btn button {
  margin: 15px 0 0;
  cursor: pointer;
  width: 100%;
  line-height: 22px;
  border: none;
  background: #3a5af9;
  color: #ffffff;
  letter-spacing: -0.1px;
}
</style>
